/* eslint-disable react-hooks/rules-of-hooks */
import z from 'zod'
import { REQUIRED_FIELD } from 'src/utils/Constants'
import { MesEnum } from 'src/enums/MesEnum'
const validationDre = () => {
  return z.object({
    ano: z
      .number({
        required_error: REQUIRED_FIELD,
        invalid_type_error: REQUIRED_FIELD,
      })
      .int()
      .positive(),
    mes: z.nativeEnum(MesEnum, {
      required_error: REQUIRED_FIELD,
      invalid_type_error: REQUIRED_FIELD,
    }),
  })
}

export { validationDre }
